import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/landingPage';
import TermsConditions from './pages/termsConditions';
import PrivacyPolicies from './pages/privacyPolicies';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicies />} />
        <Route path="/" element={<LandingPage />} />
        {/* other routes */}
      </Routes>
    </Router>
  );
}

export default App;
